import React from 'react';

const imageStyle = (size) => ({
  borderRadius: size / 2,
  objectFit: 'cover',
  width: size,
  height: size
});

const Headshot = ({ imageUrl, size }) => {
  return (
    <>
      <img style={imageStyle(size)} src={imageUrl}/>
    </>
  );
};

export default Headshot;
